import React from "react";

/*
 * The engine model for an admin test run (decided 2026-10-29): the app's real AI steps
 * (question generation, follow-up checks, English and content scoring) run on this model
 * for that run only, so models can be compared on the same test answers. The test-answer
 * writer stays fixed. Backend: openai_client.use_engine_model, ENGINE_MODELS.
 */
export const ENGINE_MODELS = [
  ["", "Engine: gpt-5.2 (default)"],
  ["gpt-6-luna", "Engine: gpt-6-luna"],
  ["gpt-5.4-mini", "Engine: gpt-5.4-mini"],
];

export function engineLabel(value) {
  return value ? `engine ${value}` : "default engine";
}

export function EngineModelSelect({ value, onChange, className = "", testId = "engine-model" }) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label="Engine model for this test run"
      title="Model the app's question generation, follow-up checks and scoring use in this test run only. Test answers are always written by the same model."
      className={`rounded border border-[color:var(--border-stone)] px-1 text-xs ${className}`}
      data-testid={testId}
    >
      {ENGINE_MODELS.map(([v, label]) => <option key={v} value={v}>{label}</option>)}
    </select>
  );
}
